import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { resolveIcon } from "./utils/app-button-icons";

const useStyles = makeStyles({
	root: {
		position: 'relative',
		height: 50,
		borderRadius: 30,
		padding: '0 28px',
		textTransform: 'none',
		fontSize: 16,
		fontWeight: 700,
		color: '#ffffff',
		background: 'linear-gradient(90deg, #00518b 0%, #0066a0 86%, #006aa3 100%)',

		'&:hover': {
			background: 'linear-gradient(90deg, #00518b 0%, #0066a0 86%, #006aa3 100%)',
			opacity: 0.95,
		},

		'&.Mui-disabled': {
			opacity: 0.6,
			color: '#ffffff',
		},

		'& .MuiButton-startIcon': {
			marginLeft: 0,
			marginRight: 8,
		},

		'& .MuiButton-endIcon': {
			marginLeft: 8,
			marginRight: 0,
		},
	},

	edgeIcons: {
		'& .MuiButton-label': {
			width: '100%',
			justifyContent: 'center',
		},

		'& .MuiButton-startIcon': {
			position: 'absolute',
			left: 30,
			margin: 0,
		},

		'& .MuiButton-endIcon': {
			position: 'absolute',
			right: 22,
			margin: 0,
		},
	},

	fullWidth: {
		width: '100%',
	},
});

const AppButton = ({
	children,
	type = 'button',
	disabled = false,
	onClick,
	startIcon = null,
	endIcon = null,
	startIconSize = 20,
	endIconSize = 20,
	fullWidth = false,
	className = '',
	style = {},
	iconLayout = 'inline',
	...buttonProps
}) => {
	const classes = useStyles();

	const resolvedStartIcon = resolveIcon(startIcon, startIconSize);
	const resolvedEndIcon = resolveIcon(endIcon, endIconSize);

	return (
		<Button
			type={type}
			disabled={disabled}
			onClick={onClick}
			startIcon={resolvedStartIcon}
			endIcon={resolvedEndIcon}
			className={`
				${classes.root}
				${fullWidth ? classes.fullWidth : ''}
				${iconLayout === 'edge' ? classes.edgeIcons : ''}
				${className}
			`}
			style={style}
			{...buttonProps}
		>
			{children}
		</Button>
	);
};

export default AppButton;